__turbopack_context__.v({
  "className": "PH2MUW_className",
  "variable": "PH2MUW_variable",
});
